export default "__VITE_ASSET__1sqvh03$__"